import i18next from "i18next";
import { pt, en, es } from "../resources";

i18next.init({
  defaultNS: "translations",
  fallbackLng: "pt",
  interpolation: {
    escapeValue: false,
    formatSeparator: ","
  },
  keySeparator: false,
  ns: ["translations"],
  react: { wait: true },
  resources: {
    pt: { translations: pt },
    en: { translations: en },
    es: { translations: es }
  }
});

export default i18next;
